export default __webpack_public_path__ + "static/media/010-hospital-1.dc8ff741.png";